import React, { useContext, useMemo } from 'react';
import useGetEntityAppLink from './useGetEntityAppLink';
import { ContentUsageType } from './useGetContentUsage';
import EntityDefinitionsContext from '../../contexts/EntityDefinitionsContext';

const EntityAppUsageItem = ({
  app,
  contentItem,
  entityDefinition,
}: {
  app: EntityDetails.App;
  contentItem: { id: string; name: string; type: ContentUsageType };
  entityDefinition: EntityDetails.Entity;
}) => {
  const goToEntity = useGetEntityAppLink({ entity: entityDefinition });

  return (
    <div>
      <span
        style={{ color: 'rgb(18, 82, 247)', cursor: 'pointer' }}
        onClick={async () => {
          await goToEntity({ contentItem });
        }}
      >
        {app.title}
      </span>
    </div>
  );
};

const Gate = ({
  app,
  contentItem,
}: {
  app: EntityDetails.App;
  contentItem: { id: string; name: string; type: ContentUsageType };
}) => {
  const { entityDefinitions } = useContext(EntityDefinitionsContext);

  const entityDefinition = useMemo(
    () => entityDefinitions.find((def) => def.id === app.entityId),
    [app.entityId, entityDefinitions],
  );

  if (!entityDefinition) {
    return null;
  }

  return (
    <EntityAppUsageItem
      app={app}
      contentItem={contentItem}
      entityDefinition={entityDefinition}
    />
  );
};

export default Gate;
